// ファイル選択
export function selectFileFieldActions () {
  $('.file_select').click(function () {
    this.parentElement.querySelector('input[type="file"]').click();
  })
}

// ファイル選択時後のアクション
export function selectFileAfterActions () {
  $('input[type="file"]').change(function () {
    let file = this.files[0];
    let fileType = file.type.split('/')[0]

    // 表示中のファイル表示領域
    let entityElement = this.closest('.card').querySelector('.card-image.entity');
    // プレビューのファイル表示領域
    let previewElement = this.closest('.card').querySelector('.card-image.preview');
    // テキストメッセージの表示領域
    let textMessageElement = this.closest('.card').querySelector('.card-image.text-message');
    // 表示名のラベル
    let noteLabel = this.closest('.card-body').querySelector('label');
    // 表示名を表示する領域
    let noteElement = this.closest('.card-body').querySelector('input[type="text"]');
    // 選択前の表示名を取得
    let originalNoteElement = this.closest('.card-body').querySelector('input[type="hidden"].original_note');
    // 削除フラグの領域
    let destroyFlgElement = this.parentElement.querySelector('input[type="hidden"].destroy_flg');

    if (this.getAttribute('data-document') == 'true') {
        // 表示名に必須ラベル追加
        showRequiredLabel(noteLabel);
        // 表示名をセット
        noteElement.value = this.files[0].name;
        // 表示名に着色
        changeColorSuccess(noteElement);
        // 選択済を表示
        textMessageElement.querySelector('span').textContent = '選択済';
    } else {
      if (fileType == 'image') {
        // 表示名をセット
        noteElement.value = this.files[0].name;
        // 表示名に着色
        changeColorSuccess(noteElement);

        // プレビューのファイル表示領域に画像を読み込む
        if (!!previewElement.querySelector('img')) {
          var reader = new FileReader();
          reader.onload = function(event) {
            previewElement.querySelector('img').setAttribute('src', reader.result);
          };
          reader.readAsDataURL(file);
        }

        // 表示中のファイル表示領域を非表示
        if (!!entityElement) {
          entityElement.classList.add('d-none');
        }
        // プレビューのファイル表示領域を表示
        if (!!previewElement) {
          previewElement.classList.remove('d-none');
        }
        // テキストメッセージの表示領域を非表示
        if (!!textMessageElement) {
          textMessageElement.classList.add('d-none');
        }
      } else {
        alert('画像以外は選択できません。');
        // 表示中のファイル表示領域を表示
        if (!!entityElement) {
          entityElement.classList.remove('d-none');
          textMessageElement.classList.add('d-none');
        } else {
          textMessageElement.classList.remove('d-none');
        }
        // プレビューのファイル表示領域を非表示
        if (!!previewElement) {
          previewElement.classList.add('d-none');
        }
        return false;
      }
    }
    // 削除フラグを倒す
    destroyFlgElement.value = false;

    // 取消ボタンを表示
    let buttonGroup = this.parentElement;
    showCancelButton(buttonGroup);
  })
}

// 取消
export function cancelSelectFile () {
  $(document).on('click', '.cancel', function () {
    // 表示中のファイル表示領域
    let entityElement = this.closest('.card').querySelector('.card-image.entity');
    // プレビューのファイル表示領域
    let previewElement = this.closest('.card').querySelector('.card-image.preview');
    // テキストメッセージの表示領域
    let textMessageElement = this.closest('.card').querySelector('.card-image.text-message');
    // ファイルフィールド
    let fileElement = this.parentElement.querySelector('input[type="file"]');
    // 表示名のラベル
    let noteLabel = this.closest('.card-body').querySelector('label');
    // 表示名を表示する領域
    let noteElement = this.closest('.card-body').querySelector('input[type="text"]');
    // 選択前の表示名を取得
    let originalNoteElement = this.closest('.card-body').querySelector('input[type="hidden"].original_note');
    // 削除/取消のボタンを表示する領域
    let buttonGroup = this.parentElement;
    // 削除フラグの領域
    let destroyFlgElement = buttonGroup.querySelector('input[type="hidden"].destroy_flg');

    if (!!fileElement.files.length || !!originalNoteElement) {
      let message = '取消します。\nよろしいですか？';

      if (window.confirm(message)) {
        if (!!originalNoteElement) {
          // 選択前の表示名をセット
          if (!!noteElement) {
            noteElement.value = originalNoteElement.value;
          }
          // テキストメッセージに登録済をセット
          if (!!textMessageElement) {
            textMessageElement.querySelector('span').textContent = '登録済';
          }
          // 表示名の必須ラベル非表示
          showRequiredLabel(noteLabel);
          // 削除ボタンを表示
          showDestroyButton(buttonGroup);
        } else {
          // 選択前の表示名をクリア
          if (!!noteElement) {
            noteElement.value = '';
          }
          // テキストメッセージに未登録をセット
          if (!!textMessageElement) {
            textMessageElement.querySelector('span').textContent = '未登録';
          }
          // 表示名の必須ラベル非表示
          hiddenRequiredLabel(noteLabel);
          // 取消ボタンを表示
          showCancelButton(buttonGroup);
        }

        // 表示中のファイル表示領域を表示
        if (!!entityElement) {
          entityElement.classList.remove('d-none');
          if (!!textMessageElement) {
            textMessageElement.classList.add('d-none');
          }
        } else {
          if (!!textMessageElement) {
            textMessageElement.classList.remove('d-none');
          }
        }
        // プレビューのファイル表示領域を非表示
        if (!!previewElement) {
          previewElement.classList.add('d-none');
        }

        // 削除フラグ
        destroyFlgElement.value = false
        // 選択されたファイルを無効化
        fileElement.value = '';
        // 表示名に着色
        changeColorMuted(noteElement);
      }
    }
  })
}

// 削除
export function destroySelectFile () {
  $(document).on('click', '.destroy', function () {
    let message = '削除します。\nよろしいですか？';

    if (window.confirm(message)) {
      // 表示中のファイル表示領域
      let entityElement = this.closest('.card').querySelector('.card-image.entity');
      // プレビューのファイル表示領域
      let previewElement = this.closest('.card').querySelector('.card-image.preview');
      // テキストメッセージの表示領域
      let textMessageElement = this.closest('.card').querySelector('.card-image.text-message');
      // 表示名のラベル
      let noteLabel = this.closest('.card-body').querySelector('label');
      // 表示名を表示する領域
      let noteElement = this.closest('.card-body').querySelector('input[type="text"]');
      // 削除/取消のボタンを表示する領域
      let buttonGroup = this.parentElement;
      // 削除フラグの領域
      let destroyFlgElement = buttonGroup.querySelector('input[type="hidden"].destroy_flg');

      // テキストメッセージに未登録をセット
      if (!!textMessageElement) {
        textMessageElement.querySelector('span').textContent = '削除中';
      }
      // 表示中のファイル表示領域を表示
      if (!!entityElement) {
        entityElement.classList.add('d-none');
        if (!!textMessageElement) {
          textMessageElement.classList.remove('d-none');
        }
      } else {
        if (!!textMessageElement) {
          textMessageElement.classList.remove('d-none');
        }
      }
      // プレビューのファイル表示領域を非表示
      if (!!previewElement) {
        previewElement.classList.add('d-none');
      }
      // 削除フラグを立てる
      destroyFlgElement.value = true;

      // 取消ボタンを表示
      showCancelButton(buttonGroup);
      // 表示名の必須ラベル非表示
      hiddenRequiredLabel(noteLabel);
      // 表示名に着色
      changeColorRed(noteElement);
    }
  })
}

// コンテンツの色を赤字に変える
function changeColorRed (element) {
  if (!!element) {
    element.classList.remove('text-success');
    element.classList.remove('text-muted');
    element.classList.add('text-danger');
  }
}

// コンテンツの色を黒字に変える
function changeColorMuted (element) {
  if (!!element) {
    element.classList.remove('text-success');
    element.classList.remove('text-danger');
    element.classList.add('text-muted');
  }
}

// コンテンツの色を緑字に変える
function changeColorSuccess (element) {
  if (!!element) {
    element.classList.remove('text-muted');
    element.classList.remove('text-danger');
    element.classList.add('text-success');
  }
}

// 取消ボタンを表示
function showCancelButton (element) {
  let button = element.querySelector('button.dynamic_button');
  if (!!button) {
    button.textContent = '取消';
    if (button.classList.contains('destroy')) {
      button.classList.remove('destroy');
      button.classList.remove('btn-danger');
      button.classList.add('cancel');
      button.classList.add('btn-warning');
    }
  }
}

// 削除ボタンを表示
function showDestroyButton (element) {
  let button = element.querySelector('button.dynamic_button');
  if (!!button) {
    button.textContent = '削除';
    if (button.classList.contains('cancel')) {
      button.classList.remove('cancel');
      button.classList.remove('btn-warning');
      button.classList.add('destroy');
      button.classList.add('btn-danger');
    }
  }
}

// 必須ラベルを表示
function showRequiredLabel (element) {
  if (!!element) {
    element.classList.add('required');
  }
}

// 必須ラベルを非表示
function hiddenRequiredLabel (element) {
  if (!!element) {
    element.classList.remove('required');
  }
}
